import { useLazyLoadQuery } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import type { levelDefinition_Query } from "@relay/levelDefinition_Query.graphql";
import { LevelDefinitionScreenContextProvider } from "./level-definition.context";
import { QUERY } from "./level-definition.graphql";
import { wrapperClass } from "./level-definition.styles";
import { LevelDefinitionTable } from "./parts/level-definition-table";
import { BaseScreen } from "../../components/base-screen";
import { H1Span } from "../../themes/font-tags";

export const LevelDefinitionScreen = () => {
	const { t } = useTranslation("common");
	const query = useLazyLoadQuery<levelDefinition_Query>(
		QUERY,
		{},
		{ fetchPolicy: "network-only" },
	);

	return (
		<LevelDefinitionScreenContextProvider>
			<BaseScreen>
				<div className={wrapperClass}>
					<H1Span>{t("levelDefinition.screenTitle")}</H1Span>
					<LevelDefinitionTable queryFragmentRef={query} />
				</div>
			</BaseScreen>
		</LevelDefinitionScreenContextProvider>
	);
};
